import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "BlogTableActions" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: `/blog/update/${_ctx.article.id}`
    }, {
      default: _withCtx(() => [
        _createVNode(_component_the_button, {
          class: "extra-small yellow mr-3",
          hint: "Редактировать"
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["to"]),
    _createVNode(_component_the_button, {
      class: "extra-small red",
      hint: "Удалить",
      loading: _ctx.state.is_deleting,
      onClick: _ctx.deleteArticle
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }, 8, ["loading", "onClick"])
  ]))
}